import { render, staticRenderFns } from "./hjgz.vue?vue&type=template&id=a98df1aa&scoped=true&"
import script from "./hjgz.vue?vue&type=script&lang=js&"
export * from "./hjgz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a98df1aa",
  null
  
)

export default component.exports